import Drawer from 'src/components/ui/Drawer'
import { CircularProgress, Box } from '@material-ui/core'
import { useState } from 'react'
import FormVincularPaciente from '../Form/formVincularPaciente'
import { ItemListagemSolicitacaoOrcamentoResponse } from 'src/types'

interface Props {
  open: boolean
  handleOnClose: (atualizou, solicitacao?) => void
  solicitacao?: ItemListagemSolicitacaoOrcamentoResponse
}

export default function DrawerVincularPaciente({
  open,
  handleOnClose,
  solicitacao
}: Props) {
  const [loading, setLoading] = useState<boolean>(false)
  return (
    <Drawer
      open={open}
      anchor="right"
      handleOnClose={() => handleOnClose(false)}
      titulo="Dados paciente"
    >
      {loading ? (
        <Box textAlign="center">
          <CircularProgress />
          <div>Carregando...</div>
        </Box>
      ) : (
        <FormVincularPaciente
          solicitacao={solicitacao}
          handleAfterSubmit={handleOnClose}
        />
      )}
    </Drawer>
  )
}
